try {
var video = document.querySelector('video');
enableInlineVideo(video);
setTimeout(function () { video.play(); }, 1000);
} catch (e) {
  
}

//# sourceMappingURL=inlinevideo.js.map
